var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotsBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#426BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5C18.5 9.88 17.38 11 16 11C14.62 11 13.5 9.88 13.5 8.5C13.5 7.12 14.62 6 16 6C17.38 6 18.5 7.12 18.5 8.5ZM16 21C14.62 21 13.5 22.12 13.5 23.5C13.5 24.88 14.62 26 16 26C17.38 26 18.5 24.88 18.5 23.5C18.5 22.12 17.38 21 16 21ZM16 13.5C14.62 13.5 13.5 14.62 13.5 16C13.5 17.38 14.62 18.5 16 18.5C17.38 18.5 18.5 17.38 18.5 16C18.5 14.62 17.38 13.5 16 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsBlue);
export default __webpack_public_path__ + "static/media/ThreeDotsBlue.3f1465d9e1ca075cc28a77ff81a3145d.svg";
export { ForwardRef as ReactComponent };